import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Locations } from "../locations/location.entity";

@Entity('rm_level')
export class RmLevel {

  @PrimaryGeneratedColumn("increment",
  {name:'level_id',
  
})
  levelId:number;
 
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"level_code"
      })
      levelCode:string;

    @Column("varchar",{
      nullable:false,
      length:30,
      name:"level_name"
      })
      levelName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  // @OneToMany(type=>RmLevel, levels=>levels.levelId,{cascade: true})
  // levelinfo:RmLevel[];
  // @OneToMany(type => Locations, loc => loc.levelInfo)
  // locationsInfo: Locations[];

 
}
